import { render, staticRenderFns } from "./ViewDependiente.vue?vue&type=template&id=8770a380&"
import script from "./ViewDependiente.vue?vue&type=script&lang=js&"
export * from "./ViewDependiente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports